import React from "react";
import { getBrowser } from "../../../utils/helperFunction";
import styles from "./Title.module.scss";
export type titleTypes = {
  children?: React.ReactNode;
  dataTestId?: string;
  id?: string;
  className?: string;
};
export const Title: React.FC<titleTypes> = ({ children, dataTestId, id, className }) => {
  const browser = getBrowser();
  return (
    <h1
      className={
        className || (browser.name === "Safari" && browser.version.match(/14/g) ? styles.title2 : styles.title)
      }
      data-testid={dataTestId}
      id={id}
    >
      {children}
    </h1>
  );
};
export default Title;
